import React from 'react';

export const pageMeta = {
  "name": "JS UTF-8 Characters",
  "link": "/javascript/utf8"
};

export default function JavascriptUtf8() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS UTF-8 Characters</h2>
      <p>Route: /javascript/utf8</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
